import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-software-internship',
  templateUrl: './software-internship.component.html',
  styleUrls: ['./software-internship.component.scss']
})
export class SoftwareInternshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
